import { useState } from "react";
import logo from "../assets/logo.png";
import axios from "axios";

const Upload = () => {
   // const [csvData, setCsvData] = useState(null);
   const [uploadStatus, setUploadStatus] = useState("");
   const [uploadStatus2, setUploadStatus2] = useState("");
   const [uploadStatus3, setUploadStatus3] = useState("");
   const [loading, setLoading] = useState(false);
   const [loading2, setLoading2] = useState(false);
   const [loading3, setLoading3] = useState(false);

   const handleFileUpload = (event) => {
      const file = event.target.files[0];
      setLoading(true);

      if (file) {
         const reader = new FileReader();

         reader.onload = async (e) => {
            // const csvContent = e.target.result;
            // setCsvData(csvContent);

            const formData = new FormData();
            formData.append("file", file);

            try {
               const response = await axios.post(
                  "https://aroma-api-9y1b.onrender.com/import-csv/",
                  formData,
                  {
                     headers: {
                        "Content-Type": "multipart/form-data",
                     },
                  }
               );

               console.log(response.data);
               setUploadStatus("File uploaded successfully!");
               setLoading(false);
            } catch (error) {
               console.error(error);
               setUploadStatus("File upload failed!");
               setLoading(false);
            }
         };

         reader.readAsText(file);
      }
   };

   const handleFileUpload2 = (event) => {
      const file = event.target.files[0];
      setLoading2(true);

      if (file) {
         const reader = new FileReader();

         reader.onload = async (e) => {
            // const csvContent = e.target.result;
            // setCsvData(csvContent);

            const formData = new FormData();
            formData.append("file", file);

            try {
               const response = await axios.post(
                  "https://aroma-api-9y1b.onrender.com/import-csv-step2/",
                  formData,
                  {
                     headers: {
                        "Content-Type": "multipart/form-data",
                     },
                  }
               );

               console.log(response.data);
               setUploadStatus2("File uploaded successfully!");
               setLoading2(false);
            } catch (error) {
               console.error(error);
               setUploadStatus2("File upload failed!");
               setLoading2(false);
            }
         };

         reader.readAsText(file);
      }
   };

   const handleFileUpload3 = (event) => {
      const file = event.target.files[0];
      setLoading3(true);

      if (file) {
         const reader = new FileReader();

         reader.onload = async (e) => {
            // const csvContent = e.target.result;
            // setCsvData(csvContent);

            const formData = new FormData();
            formData.append("file", file);

            try {
               const response = await axios.post(
                  "https://aroma-api-9y1b.onrender.com/import-csv-step3/",
                  formData,
                  {
                     headers: {
                        "Content-Type": "multipart/form-data",
                     },
                  }
               );

               console.log(response.data);
               setUploadStatus3("File uploaded successfully!");
               setLoading3(false);
            } catch (error) {
               console.error(error);
               setUploadStatus3("File upload failed!");
               setLoading3(false);
            }
         };

         reader.readAsText(file);
      }
   };
   return (
      <div className="p-5 container">
         <div className="d-flex align-items-center mb-3 mx-4">
            <img src={logo} height={60} />
            <div className="ms-3">
               <h6>Aroma-Tune By Innosol, Inc.</h6>
               <h6></h6>
            </div>
            <p className="py-4 me-0 ms-auto text-end">
               CREATE BEST SELLING PERFUMES, FRAGRANCES & FLAVORS,
               <br />
               INHOUSE & ON-DEMAND
            </p>
         </div>
         <div className="row">
            <div className="col-6">
               <h2>Upload .csv First Step File</h2>
               <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileUpload}
                  className="w-100"
               />
            </div>
            {loading && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <div class="spinner-border text-light" role="status">
                     <span class="visually-hidden">Loading...</span>
                  </div>
               </div>
            )}
            {uploadStatus && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <p>{uploadStatus}</p>
               </div>
            )}
            {/* {csvData && (
               <div>
                  <h3>Uploaded CSV Data:</h3>
                  <pre>{csvData}</pre>
               </div>
            )} */}
         </div>
         <div className="row mt-3">
            <div className="col-6">
               <h2>Upload .csv Second Step File</h2>
               <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileUpload2}
                  className="w-100"
               />
            </div>
            {loading2 && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <div class="spinner-border text-light" role="status">
                     <span class="visually-hidden">Loading...</span>
                  </div>
               </div>
            )}
            {uploadStatus2 && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <p>{uploadStatus2}</p>
               </div>
            )}
            {/* {csvData && (
               <div>
                  <h3>Uploaded CSV Data:</h3>
                  <pre>{csvData}</pre>
               </div>
            )} */}
         </div>
         <div className="row mt-3">
            <div className="col-6">
               <h2>Upload .csv Third Step File</h2>
               <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileUpload3}
                  className="w-100"
               />
            </div>
            {loading3 && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <div class="spinner-border text-light" role="status">
                     <span class="visually-hidden">Loading...</span>
                  </div>
               </div>
            )}
            {uploadStatus3 && (
               <div className="col-6 d-flex pt-5 align-items-center ">
                  <p>{uploadStatus3}</p>
               </div>
            )}
            {/* {csvData && (
               <div>
                  <h3>Uploaded CSV Data:</h3>
                  <pre>{csvData}</pre>
               </div>
            )} */}
         </div>
      </div>
   );
};

export default Upload;
